import React from "react";
import ReactECharts from "echarts-for-react";
import appconstants from "../../../themes/appconstant";

const WhoCharts = ({ text, data, sentTo, submissions }) => {
  const chartOptions = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#ffffff",
      borderColor: "#f0f0f0",
      borderWidth: 1,
      borderRadius: 8,
      padding: 12,
      extraCssText: "box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);",
      axisPointer: {
        type: "line",
        lineStyle: {
          color: "#ff4d6d",
          type: "dashed",
          width: 1,
        },
      },
      formatter: (params) => {
        const point = params[0];
        return `
          <div style="font-family: sans-serif; display: flex; flex-direction: column; gap: 4px;">
            <div style="display: flex; justify-content: space-between; gap: 24px;">
              <span style="color: #606266; font-size: 13px;">People</span>
              <span style="color: #303133; font-weight: 600; font-size: 13px;">${Math.round(point.data[0])}</span>
            </div>
            <div style="display: flex; justify-content: space-between; gap: 24px;">
              <span style="color: #606266; font-size: 13px;">Avg. Score</span>
              <span style="color: #303133; font-weight: 600; font-size: 13px;">${Math.round(point.data[1])}</span>
            </div>
          </div>
        `;
      },
    },
    xAxis: {
      type: "value",
      name: "No of People",
      nameLocation: "middle",
      nameGap: 30,
      axisLabel: {
        formatter: "{value}",
      },
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 100,
      axisLabel: {
        formatter: "{value}",
      },
    },
    series: [
      {
        type: "line",
        data: data?.map((d) => [
          Number(d.userCount).toFixed(2),
          Number(d.avgScore).toFixed(2),
        ]),
        smooth: true,
        showSymbol: true,
        symbol: "circle",
        symbolSize: 16,
        itemStyle: {
          color: "#ff4d6d",
          borderColor: "#ffffff",
          borderWidth: 3,
          shadowColor: "rgba(255, 77, 109, 0.4)",
          shadowBlur: 8,
        },
        emphasis: {
          itemStyle: {
            symbolSize: 20,
            borderWidth: 4,
            shadowColor: "rgba(255, 77, 109, 0.6)",
            shadowBlur: 10,
          },
        },
        lineStyle: {
          width: 3,
        },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "rgba(255, 77, 109, 0.2)" },
              { offset: 1, color: "rgba(255, 77, 109, 0)" },
            ],
            global: false,
          },
        },
      },
    ],
  };

  return (
    <div className=" border-royalPurple bg-white border rounded-[10px]">
      <div className="text-base font-semibold text-dark p-4  border-b">
        {text}
      </div>
      <div className="p-6">
        <div className="flex justify-between">
          <div>{appconstants.who5Score}</div>
          <div className="flex gap-4">
            <div className="py-2 px-3 border border-bgpurple  text-xs font-normal text-gray60 rounded-[10px]">
              {appconstants.sentTo}{" "}
              <span className="text-dark font-semibold">{sentTo}</span>
            </div>
            <div className="py-2 px-3 border border-bgpurple  text-xs font-normal text-gray60 rounded-[10px]">
              {appconstants.submissions}{" "}
              <span className="text-dark font-semibold">{submissions}</span>
            </div>
          </div>
        </div>
        {data.length == 0 ? (
          <div className="flex justify-center my-5 text-lg">No Submissions</div>
        ) : (
          <ReactECharts option={chartOptions} style={{ height: "400px" }} />
        )}
      </div>
    </div>
  );
};

export default WhoCharts;
